// 获取全局唯一值，userId或者授信单等

import { getUserInfoApi } from '@/appApi';
import { EddaBankInfo } from '@/interface/KKC/edda';
import { LittleBank } from '@/interface/KKC/repayment';
import { selectBankInfo, selectCardInfo } from '@/pages/KKC/repayment/api';
import { setUserInfo } from '@/vhkstore/slices/app';
import vhkStore from '../vhkstore';

/**
 * needUpdate 是否需要获取最新数据
 */
export const getGlobalUserInfo = async (needUpdate = false) => {
  const { userInfo } = vhkStore.getState().h5AppReducer;
  if (
    needUpdate ||
    !userInfo ||
    !userInfo.userId ||
    !userInfo.userName ||
    !userInfo.englishName ||
    !userInfo.englishNameShow
  ) {
    return getUserInfoApi().then((u) => {
      console.log(u, '00000用户信息');
      vhkStore.dispatch(setUserInfo({ userInfo: u }));
      return u;
    });
  }
  return Promise.resolve(userInfo);
};

// 重新登录之后，判断一次是否是同一个用户
export const compareIfChangeUserInfo = async () => {
  const { userInfo } = vhkStore.getState().h5AppReducer;
  const newUserInfo = await getUserInfoApi();
  return userInfo.userId === newUserInfo.userId;
};

export enum Values {
  AllBank = 1,
  EddaBank = 2,
}

const CacheMap: {
  [Values.AllBank]: null | {
    bankAll: LittleBank[];
    bankCommon: LittleBank[];
  };
  [Values.EddaBank]: null | EddaBankInfo[];
} = {
  [Values.AllBank]: null,
  [Values.EddaBank]: null,
};

const ApiMap: {
  [Values.AllBank]: () => Promise<{
    bankAll: LittleBank[];
    bankCommon: LittleBank[];
  }>;
  [Values.EddaBank]: () => Promise<EddaBankInfo[]>;
} = {
  [Values.AllBank]: selectBankInfo,
  [Values.EddaBank]: selectCardInfo,
};

export const getGlobalDatas = (value: Values) => {
  const allBanks = CacheMap[value];

  if (!allBanks) {
    return ApiMap[value]().then((v) => {
      CacheMap[value] = v as any;
      return v;
    });
  }

  return Promise.resolve(allBanks);
};
